import React from 'react';
import ReactDOM from 'react-dom/client';
import PrimeReact from 'primereact/api';
// import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "primereact/resources/themes/lara-light-teal/theme.css"; //theme
// import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
// import "primereact/resources/themes/lara-light-purple/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import 'primeflex/primeflex.css';
// import './styles/layout/layout.scss';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './styles/index.scss';




PrimeReact.ripple = true;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
